import Diamond from '../../src/legacy/Diamond.tsx';
export default Diamond;
